import config from '@/config';
import SettingsSidebar from '@/partials/shared/settings/settings-sidebar/settings-sidebar';
import { Outlet } from 'react-router-dom';

export default function GroupSettings() {
  return (
    <>
      {/* Page header */}
      <div className="mb-5">
        {/* Title */}
        <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Gruppinställningar</h1>
      </div>

      {/* Content */}
      <div className="bg-white dark:bg-gray-800 shadow-sm rounded-xl mb-8">
        <div className="flex flex-col md:flex-row md:-mr-px">
          <SettingsSidebar links={config.app.group.settings.links} />
          <Outlet />
        </div>
      </div>
    </>
  );
}
